export default __webpack_public_path__ + "static/media/vat-paid.bba45bcd.svg";